import { boot } from '@dazn/bootstrap-lib';
const BYTES_PER_CHARACTER = 2;

export const createAsyncStorageAPI = (
    syncStorage: boot.storage.SyncStorage,
    maxSize: number,
): boot.storage.AsyncStorage => ({
    getItem: (key: string) => Promise.resolve(syncStorage.getItem(key)),
    setItem: (key: string, itemValue: string) => {
        const item = String(itemValue);
        if (item.length * BYTES_PER_CHARACTER > maxSize) {
            return Promise.reject(
                new RangeError(
                    `Too many bytes in the item to store (max: ${maxSize})`,
                ),
            );
        }

        Promise.resolve(syncStorage.setItem(key, item)).catch(error =>
            console.error(error),
        );

        return Promise.resolve(item);
    },
    removeItem: (k: string) => Promise.resolve(syncStorage.removeItem(k)),
    clear: () => Promise.resolve(syncStorage.clear()),
});
